import { createContainer } from 'react-tracked';
import { useReducer } from 'react';

const initialState = {
    showAnnualStatementModal: false,
    showQuarterlyStatementModal: false,
    showStatementOptionModal: false,
    showTaxStatementModal: false,
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'openStatementOptionModal':
            return {
                ...state,
                showStatementOptionModal: true,
            };
        case 'closeStatementOptionModal':
            return {
                ...state,
                showStatementOptionModal: false,
            };
        case 'openQuarterlyStatementModal':
            return {
                ...state,
                showQuarterlyStatementModal: true,
            };
        case 'closeQuarterlyStatementModal':
            return {
                ...state,
                showQuarterlyStatementModal: false,
            };
        case 'openAnnualStatementModal':
            return {
                ...state,
                showAnnualStatementModal: true,
            };
        case 'closeAnnualStatementModal':
            return {
                ...state,
                showAnnualStatementModal: false,
            };
        default:
            return state;
    }
};

const useValue = () => useReducer(reducer, initialState);

export const {
    Provider: StatementProvider,
    useTrackedState: useStatementState,
    useUpdate: useStatementDispatch,
} = createContainer(useValue);
